// Library Methods
import { useContext, useMemo } from "react";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

// Components
import D15Graph from "./D15Graph/D15Graph";
import IshiharaGraph from "./IshiharaGraph/IshiharaGraph";

const ColorVisionGraph = () => {
  const { examReport } = useContext(ReportSectionContext);

  const isD15 = useMemo(
    () => examReport?.exam?.algorithm?.includes("D_15"),
    [examReport?.exam?.algorithm]
  );

  const isIshihara = useMemo(
    () => examReport?.exam?.algorithm?.includes("ISHIHARA"),
    [examReport?.exam?.algorithm]
  );

  return (
    <>
      {isD15 && <D15Graph />}
      {isIshihara && <IshiharaGraph />}
    </>
  );
};

export default ColorVisionGraph;
